module.exports = __webpack_public_path__ + "img/20190805161215570.83b5fd98.png";